import React from "react";
import PropTypes from "prop-types";

{
  /* <style type="text/css">
	.st0{fill:#F2ECE1;}
	.st1{fill:#F1ECE1;}
	.st2{fill:#EAB691;}
	.st3{fill:none;stroke:#EAB691;stroke-width:8.134;stroke-miterlimit:10;}
	.st4{fill:#F4EEE3;}
	.st5{fill:#E84929;}
	.st6{fill:#D4B197;}
	.st7{fill:#E8D1BC;}
	.st8{fill:#6B0B1C;}
	.st9{fill:#F9AD8F;}
</style> */
}

const Wordmark = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    default:
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 772 101">
      <g>
        <g>
          <g>
            <path
              d="M52.27,52.18c0,3.94-2.2,6.39-5.75,6.39c-5.09,0-6.14-5.2-6.18-5.42l-0.08-0.4l-5.5,2.58l0.06,0.25
        c0.02,0.09,2.21,8.95,11.7,8.95c7,0,11.71-4.96,11.71-12.35l0-18.79h-5.96L52.27,52.18z"
              fill={color}
            />
          </g>
          <polygon
            points="115.59,33.39 115.59,63.89 140.75,63.89 140.75,57.93 121.55,57.93 121.55,51.56 137.61,51.56 137.61,45.64 
      121.55,45.64 121.55,39.35 140.54,39.35 140.54,33.39"
            fill={color}
          />
          <polygon
            points="173.87,33.39 166.12,47.93 158.37,33.39 151.9,33.39 163.12,54.35 163.12,63.89 169.08,63.89 169.08,54.35 
			180.35,33.39"
            fill={color}
          />
          <g>
            <path
              d="M86.34,59C80.8,59,76.3,54.5,76.3,48.96c0-5.54,4.49-10.03,10.04-10.03c5.54,0,10.04,4.49,10.04,10.03
				C96.38,54.5,91.88,59,86.34,59 M86.34,33.09c-8.77,0-15.87,7.11-15.87,15.87c0,8.77,7.11,15.87,15.87,15.87
				c8.77,0,15.87-7.11,15.87-15.87C102.21,40.19,95.11,33.09,86.34,33.09"
              fill={color}
            />
          </g>
        </g>
        <g>
          <path
            d="M298.85,50.57l4.53-11.66l4.5,11.66H298.85z M307.82,33.71h-8.88l-11.77,30.5h6.43l2.94-7.68h13.61l2.99,7.68h6.43
			l-11.69-30.3L307.82,33.71z"
            fill={color}
          />
          <polygon
            points="353.33,57.95 340.43,33.88 340.34,33.71 331.05,33.71 331.05,64.21 337.01,64.21 337.01,39.97 349.91,64.04 
			350,64.21 359.29,64.21 359.29,33.71 353.33,33.71"
            fill={color}
          />
          <g>
            <path
              d="M386.55,58.25h-6.43V39.67h6.43c5.65,0,9.16,3.56,9.16,9.29C395.71,54.69,392.2,58.25,386.55,58.25 M386.55,33.71h-12.39
				v30.5h12.39c8.76,0,15.12-6.41,15.12-15.25C401.67,40.12,395.31,33.71,386.55,33.71"
              fill={color}
            />
          </g>
          <rect x="415.36" y="33.71" width="5.96" height="30.5" fill={color} />
          <polygon
            points="459.09,39.56 459.17,39.47 459.17,33.71 435.49,33.71 435.49,39.67 451.1,39.67 435.35,58.36 435.28,58.45 
			435.28,64.21 460.02,64.21 460.02,58.25 443.35,58.25"
            fill={color}
          />
          <polygon
            points="496.6,39.56 496.67,39.47 496.67,33.71 473,33.71 473,39.67 488.6,39.67 472.86,58.36 472.79,58.45 472.79,64.21 
			497.53,64.21 497.53,58.25 480.86,58.25"
            fill={color}
          />
          <g>
            <path
              d="M225.58,45.99c-5.74-1.41-7.68-2.15-7.64-4.93c0.05-2.77,3.26-3.46,5.34-3.41c5.75,0.16,6.07,4.53,6.14,4.7h6.08
				c-0.03-0.07-0.57-9.39-12.09-9.39c-8.05,0-11.68,4.69-11.61,9.39c0.07,4.88,4.3,7.36,9.2,8.4c5.34,1.13,8.65,1.9,8.72,5.35
				c0.05,2.09-1.46,4.01-5.62,4.03c-7.18,0.03-7.23-5.15-7.25-5.19l-6.19,0.04c0,1.15,1.38,5.1,3.02,6.58
				c2.07,1.87,4.7,3.42,10.43,3.42c6.18,0,11.91-3.69,11.91-10.22C236.02,48.2,227.98,46.58,225.58,45.99"
              fill={color}
            />
            <path
              d="M263.46,58.97c-5.53,0-10.01-4.48-10.01-10.01s4.48-10.01,10.01-10.01c3.91,0,7.28,2.24,8.93,5.51l5.11-3.01
				c-2.68-5-7.96-8.41-14.04-8.41c-8.79,0-15.92,7.13-15.92,15.92c0,8.79,7.13,15.92,15.92,15.92c6.19,0,11.55-3.54,14.18-8.71
				l-5.11-3.01C270.94,56.59,267.48,58.97,263.46,58.97"
              fill={color}
            />
            <path
              d="M524.37,59c-5.54,0-10.04-4.49-10.04-10.04c0-5.54,4.49-10.03,10.04-10.03s10.04,4.49,10.04,10.03
				C534.41,54.5,529.91,59,524.37,59 M524.37,33.09c-8.77,0-15.87,7.11-15.87,15.87c0,8.77,7.11,15.87,15.87,15.87
				s15.87-7.11,15.87-15.87C540.24,40.19,533.14,33.09,524.37,33.09"
              fill={color}
            />
          </g>
        </g>
        <g>
          <path
            d="M619.05,50.57l4.53-11.66l4.49,11.66H619.05z M628.02,33.71h-8.88l-11.76,30.5h6.43l2.94-7.68h13.61l2.99,7.68h6.43
			l-11.69-30.3L628.02,33.71z"
            fill={color}
          />
          <polygon
            points="658.16,33.71 652.2,33.71 652.2,64.21 675.66,64.21 675.66,58.25 658.16,58.25"
            fill={color}
          />
          <polygon
            points="748.17,33.71 748.17,57.95 735.27,33.88 735.19,33.71 725.89,33.71 725.89,64.21 731.86,64.21 731.86,39.97 
			744.75,64.04 744.84,64.21 754.13,64.21 754.13,33.71"
            fill={color}
          />
          <g>
            <path
              d="M586.39,45.99c-5.74-1.41-7.68-2.15-7.64-4.93c0.05-2.77,3.26-3.46,5.34-3.41c5.75,0.16,6.07,4.53,6.14,4.7h6.08
				c-0.03-0.07-0.57-9.39-12.09-9.39c-8.05,0-11.68,4.69-11.61,9.39c0.07,4.88,4.3,7.36,9.2,8.4c5.34,1.13,8.65,1.9,8.72,5.35
				c0.05,2.09-1.46,4.01-5.62,4.03c-7.18,0.03-7.23-5.15-7.25-5.19l-6.19,0.04c0,1.15,1.38,5.1,3.02,6.58
				c2.07,1.87,4.7,3.42,10.43,3.42c6.18,0,11.91-3.69,11.91-10.22C596.83,48.2,588.79,46.58,586.39,45.99"
              fill={color}
            />
            <path
              d="M698.64,59c-5.54,0-10.04-4.49-10.04-10.04c0-5.54,4.49-10.04,10.04-10.04c5.54,0,10.04,4.49,10.04,10.04
				C708.68,54.5,704.18,59,698.64,59 M698.64,33.09c-8.77,0-15.87,7.11-15.87,15.87c0,8.77,7.11,15.87,15.87,15.87
				s15.87-7.11,15.87-15.87C714.51,40.19,707.41,33.09,698.64,33.09"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

Wordmark.defaultProps = {
  className: ``,
  color: `black`,
  direction: `>`
};

Wordmark.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  direction: PropTypes.string
};

export default Wordmark;
